<div class="content">
    <div *ngIf="errorMessages.length !== 0">
        <div>
            <div *ngFor="let errorMessage of errorMessages" class="list-item">
                <div class="fa-duotone fa-times-circle alert-note" style="color: #D32F2F;"></div>
                <div>{{errorMessage}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="warningMessages.length !== 0">
        <div>
            <div *ngFor="let warningMessage of warningMessages" class="list-item">
                <div class="fa-duotone fa-exclamation-triangle alert-note" style="color: #FBC02D;"></div>
                <div>{{warningMessage}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="infoMessages.length !== 0">
        <div>
            <div *ngFor="let infoMessage of infoMessages" class="list-item">
                <div class="fa-duotone fa-exclamation-circle alert-note" style="color: #9fa8da;"></div>
                <div>{{infoMessage}}</div>
            </div>
        </div>
    </div>
</div>